module.exports = __webpack_public_path__ + "img/empty.a2bdfe28.png";